import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getImage } from '../Images/utilities/imageUtils.js';
import { DEFAULT_SKILL_ICON, normalizeSkillIcon } from './iconOptions.js';

const IconDisplay = ({ icon, userId, label = 'Skill', size = 40, className = '' }) => {
  const normalized = normalizeSkillIcon(icon);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let active = true;
    setImageSrc(null);
    if (normalized?.type !== 'image' || !userId) return () => { active = false; };
    getImage(userId, normalized.imageId)
      .then((image) => { if (active) setImageSrc(image?.base64 || null); })
      .catch(() => { if (active) setImageSrc(null); });
    return () => { active = false; };
  }, [normalized?.type, normalized?.imageId, userId]);

  const style = { width: size, height: size, minWidth: size };
  if (normalized?.type === 'image' && imageSrc) {
    return <img src={imageSrc} alt={`${label} icon`} className={`rounded skill-icon ${className}`} style={{ ...style, objectFit: 'cover' }} />;
  }

  const iconClass = normalized?.type === 'bootstrap' ? normalized.value : DEFAULT_SKILL_ICON;
  return (
    <span className={`d-inline-flex align-items-center justify-content-center rounded bg-body-tertiary skill-icon ${className}`} style={style} role="img" aria-label={`${label} icon`}>
      <i className={`bi ${iconClass}`} aria-hidden="true" style={{ fontSize: Math.max(16, size * 0.55) }} />
    </span>
  );
};

IconDisplay.propTypes = { icon: PropTypes.object, userId: PropTypes.string, label: PropTypes.string, size: PropTypes.number, className: PropTypes.string };
export default IconDisplay;
